import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SelectCityService {

  private url = 'data/selectCity.json';
  private isOpenSelectCitySubject = new BehaviorSubject<boolean>(false);
  isOpenSelectCity$ = this.isOpenSelectCitySubject.asObservable();

  constructor(private http: HttpClient) {}

  getData(): Observable<any> {
    return this.http.get<any>(this.url);
  }

  openSelectCity(): void {
    this.isOpenSelectCitySubject.next(true);
  }

  closeSelectCity(): void {
    this.isOpenSelectCitySubject.next(false)
  }
}
